<template>
    <SOSlotCard :card-type="'shadow'">
        <template v-slot:card_head>
            <span
                v-if="setoran.status === 1"
                class="f-regular f-12 f-c-midgrey bg-gray rounded m-d-4"
                style="padding: 2px 4px"
            >
                Menunggu konfirmasi
            </span>
            <div class="d-flex-between-center f-16 f-semi f-c-black m-d-4">
                <div
                    class="m-d-0 f-c-black"
                    v-if="search !== ''"
                    v-html="searchHighlight('Rp ' + formatRupiah(setoran.total_nominal), search)"
                ></div>
                <div class="m-d-0 f-c-black" v-else>Rp {{ formatRupiah(setoran.total_nominal) }}</div>
                <img src="@/assets/icons/chevron_right_4.svg" />
            </div>
        </template>
        <template v-slot:card_body>
            <div class="f-regular f-13 f-c-midgrey m-d-2">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M7.9999 2L0.666565 7.6L1.47323 8.66L2.66656 7.74667V14H13.3332V7.74667L14.5266 8.65333L15.3332 7.6L7.9999 2ZM5.33323 10C4.96657 10 4.66656 9.7 4.66656 9.33333C4.66656 8.96667 4.96657 8.66667 5.33323 8.66667C5.6999 8.66667 5.9999 8.96667 5.9999 9.33333C5.9999 9.7 5.6999 10 5.33323 10ZM7.9999 10C7.63323 10 7.33323 9.7 7.33323 9.33333C7.33323 8.96667 7.63323 8.66667 7.9999 8.66667C8.36657 8.66667 8.66656 8.96667 8.66656 9.33333C8.66656 9.7 8.36657 10 7.9999 10ZM10.6666 10C10.2999 10 9.9999 9.7 9.9999 9.33333C9.9999 8.96667 10.2999 8.66667 10.6666 8.66667C11.0332 8.66667 11.3332 8.96667 11.3332 9.33333C11.3332 9.7 11.0332 10 10.6666 10Z"
                        fill="#C8D0DD"
                    />
                </svg>
                <span
                    class="f-c-black"
                    v-if="search !== ''"
                    v-html="searchHighlight(setoran.nama_workshop, search)"
                ></span>
                <span v-else class="m-l-4">{{ setoran.nama_workshop }}</span>
            </div>
            <div class="f-regular f-13 f-c-midgrey m-d-2" v-for="(tujuan_setor, i) in setoran.tujuan_setor" :key="i">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M3.33335 2.6665C3.70154 2.6665 4.00002 2.96498 4.00002 3.33317V7.4165C4.00002 7.85853 4.17562 8.28245 4.48818 8.59502C4.80074 8.90758 5.22466 9.08317 5.66669 9.08317H11.0572L9.27862 7.30457C9.01827 7.04423 9.01827 6.62212 9.27862 6.36177C9.53896 6.10142 9.96107 6.10142 10.2214 6.36177L13.1381 9.27843C13.3984 9.53878 13.3984 9.96089 13.1381 10.2212L10.2214 13.1379C9.96107 13.3983 9.53896 13.3983 9.27862 13.1379C9.01827 12.8776 9.01827 12.4554 9.27862 12.1951L11.0572 10.4165H5.66669C4.87104 10.4165 4.10798 10.1004 3.54537 9.53782C2.98276 8.97521 2.66669 8.21215 2.66669 7.4165V3.33317C2.66669 2.96498 2.96516 2.6665 3.33335 2.6665Z"
                        fill="#C8D0DD"
                    />
                </svg>
                <span
                    class="m-l-4 f-c-black"
                    v-if="search !== ''"
                    v-html="searchHighlight(tujuan_setor.nama_akun, search)"
                ></span>
                <span class="m-l-4" v-else>{{ tujuan_setor.nama_akun }}</span>
            </div>
        </template>
        <template v-slot:card_footer>
            <div class="row m-0 need-confirm f-12 setoran-workshop-card-footer-bg" v-if="setoran.status === 1">
                <div
                    class="col-md-6 col-sm-6 col-6 p-0 nomore"
                    v-if="search !== ''"
                    v-html="searchHighlight('Oleh ' + setoran.nama_karyawan, search)"
                ></div>
                <div class="col-md-6 col-sm-6 col-6 p-0 nomore" v-else>Oleh {{ setoran.nama_karyawan }}</div>
                <div
                    class="col-md-6 col-sm-6 col-6 p-0 text-right"
                    v-if="search !== ''"
                    v-html="searchHighlight(setoran.waktu_transfer_formated, search)"
                ></div>
                <div class="col-md-6 col-sm-6 col-6 p-0 text-right" v-else>({{ setoran.waktu_transfer_formated }})</div>
            </div>

            <div class="row m-0 need-confirm f-12 align-items-center" v-else>
                <div
                    class="col-md-4 col-sm-4 col-4 p-0 nomore"
                    v-if="search !== ''"
                    v-html="searchHighlight('Oleh ' + setoran.nama_karyawan, search)"
                ></div>
                <div class="col-md-4 col-sm-4 col-4 p-0 nomore" v-else>Oleh {{ setoran.nama_karyawan }}</div>
                <div
                    class="col-md-5 col-sm-5 col-5 p-0 text-right"
                    v-if="search !== ''"
                    v-html="searchHighlight(setoran.waktu_transfer_formated, search)"
                ></div>
                <div class="col-md-5 col-sm-5 col-5 p-0 text-right" v-else>({{ setoran.waktu_transfer_formated }})</div>
                <div class="col-md-3 col-sm-3 col-3 p-0 text-right">
                    <span class="badge-tag tg-green" v-if="setoran.status === 2">Disetujui</span>
                    <span class="badge-tag tg-red" v-if="setoran.status === 3">Ditolak</span>
                </div>
            </div>
        </template>
    </SOSlotCard>
</template>

<script>
import SOSlotCard from "@/so-components/global/slot/SOSlotCard";

export default {
    name: "CardSetoranKasWorkshop",
    components: {
        SOSlotCard,
    },
    props: {
        setoran: Object,
        search: {
            type: String,
            default: "",
        },
    },
    mounted() {
        this.fixCardUI();
    },
    methods: {
        fixCardUI() {
            setTimeout(() => {
                $(".card").addClass("setoran-workshop-card-fix");
                $(".card-footer").addClass("setoran-workshop-card-footer-fix");
            }, 200);
        },
    },
};
</script>

<style>
.need-confirm {
    padding: 4px 16px;
    border-bottom-right-radius: 5px;
    border-bottom-left-radius: 5px;
}

.setoran-workshop-card-footer-bg {
    background: linear-gradient(90deg, #fff8e1 0%, #ffffff 100%);
}

.setoran-workshop-card-footer-fix {
    padding: 0 !important;
}

.setoran-workshop-card-fix {
    padding-bottom: 0 !important;
}
</style>
